import {Action} from '@ngrx/store';

export const GET_AVAILABILITY = '[Availability] Get Availability';
export const GET_AVAILABILITY_SUCCESS = '[Availability] Get Availability Success';
export const GET_AVAILABILITY_ERROR = '[Availability] Get Availability Error';

export const GET_AVAILABLE_FREELANCERS = '[Availability] Get Availabile Freelancers';
export const GET_AVAILABLE_FREELANCERS_SUCCESS = '[Availability] Get Availabile Freelancers Success';
export const GET_AVAILABLE_FREELANCERS_ERROR = '[Availability] Get Availabile Freelancers Error';

export class GetAvailability implements Action {
  readonly type = GET_AVAILABILITY;

  constructor(public payload: any) {
  }
}

export class GetAvailabilitySuccess implements Action {
  readonly type = GET_AVAILABILITY_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetAvailabilityError implements Action {
  readonly type = GET_AVAILABILITY_ERROR;

  constructor(public payload: any) {
  }
}

export class GetAvailableFreelancers implements Action {
  readonly type = GET_AVAILABLE_FREELANCERS;

  constructor(public payload: any) {
  }
}

export class GetAvailableFreelancersSuccess implements Action {
  readonly type = GET_AVAILABLE_FREELANCERS_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetAvailableFreelancersError implements Action {
  readonly type = GET_AVAILABLE_FREELANCERS_ERROR;

  constructor(public payload: any) {
  }
}

export type AvailabilityAction =
  GetAvailability
  | GetAvailabilitySuccess
  | GetAvailabilityError
  | GetAvailableFreelancers
  | GetAvailableFreelancersSuccess
  | GetAvailableFreelancersError;



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/availabilities/store/actions/availability.action.ts